import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import ReactTooltip from 'react-tooltip';
import Select from "react-select";

function SingleResult() {
    document.title = "Manage Single Result Entry | " + window.companyName;
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [isLoading, setIsloading] = useState(false);
    const [all_studentDetails, setAllStudentDetails] = useState([]);
    const [allstudentDetails, setStudentDetails] = useState([]);
    const [schoolYears, setSchoolYear] = useState([]);
    const [schoolTerm, setSchoolTerm] = useState([]);
    const [all_class, setAllClass] = useState([]);
    const [sch_category, setSchCatgory] = useState([]);
    const [all_category, setCatogory] = useState([]);
    const [class_id, setClassId] = useState([]);

    const [clasSelect, setClassSelect] = useState([]);

    const [all_subjects, setAllSubjects] = useState([]);
    const [validationErrors, setValidationErrors] = useState(null);
    const [rows, setRows] = useState([
        {
            admin_number: "",
            ca1_score: "",
            ca2_score: "",
            exam_score: "",
            total: "",
        },
    ]);

    const [formData, setFormData] = useState({
        year: "",
        term: "",
        subject: "",
        class: "",
        school_category: "",
    });

    const handleFormDataChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });

    };
    //console.log(formData.class);


    // create a function to fetch class data here
    useEffect(() => {
        axios.get(`/api/fetch_all_student_result`).then((res) => {
            if (res.data.status === 200) {
                setStudentDetails(res.data.student_record);
            }
            setLoading(false);
        });
    }, []);


    // create a function to fetch class data here
    useEffect(() => {
        axios.get(`/api/fetch_all_details`).then((res) => {
            if (res.data.status === 200) {
                setAllClass(res.data.allDetails.class_details);
                setAllSubjects(res.data.allDetails.subject_details);
                setSchoolTerm(res.data.allDetails.term_details);
                setSchoolYear(res.data.allDetails.session_details);
                setSchCatgory(res.data.allDetails.sch_category_details);
                setCatogory(res.data.allDetails.sch_category_details)
            }
        });
    }, []);

    const handleOnChange = (e, index) => {
        if (["ca1_score", "ca2_score"].includes(e.target.name)) {
            if (e.target.value > 20)
                return toast.error("CA score not more than 20", {
                    theme: "colored",
                });
        }

        if (e.target.name === "exam_score") {
            if (e.target.value > 60)
                return toast.error("Exam score not more than 60", {
                    theme: "colored",
                });
        }

        rows[index] = {
            ...rows[index],
            [e.target.name]: e.target.value,
        };

        if (!["admin_number", "total"].includes(e.target.name)) {
            rows[index] = {
                ...rows[index],
                total:
                    parseInt(rows[index].ca1_score || 0) +
                    parseInt(rows[index].ca2_score || 0) +
                    parseInt(rows[index].exam_score || 0),
            };
        }

        setRows([...rows]);
    };

    const handleSelectChange = (e, i) => {
        rows[i] = { ...rows[i], admin_number: e.target.value };

        setRows([...rows]);
    };

    const addRow = () => {
        const newRow = {
            admin_number: "",
            ca1_score: "",
            ca2_score: "",
            exam_score: "",
            total: "",
        };

        setRows([...rows, newRow]);
    };

    const removeRow = (e, i) => {
        rows.splice(i, 1);

        setRows([...rows]);
    };

    const onSubmit = (e) => {
        setIsloading(true);
        try {
            // let create the api url here
            axios
                .post(`/api/single_result_save`, {
                    data: rows,
                    year: formData.year,
                    term: formData.term,
                    subject: formData.subject,
                    school_category: formData.school_category,
                    class: class_id,
                })
                .then((res) => {
                    if (res.data.status === 200) {
                        setIsloading(false);
                        setValidationErrors(null);
                        toast.success(res.data.message, {
                            theme: "colored",
                        });
                        localStorage.setItem("Rtid", res.data.resultAll.tID.tid_code);
                        history.push('/admin/view-position');
                    }
                    else if (res.data.status === 403) {
                        toast.error(res.data.message, {
                            theme: "colored",
                        });
                        setIsloading(false);
                    }
                })
                .catch((error) => {
                    setIsloading(false);
                    setValidationErrors(error.response.data.errors);
                });
        } catch (error) {
            setIsloading(false);
            // Handle the error
            toast.error("sorry, server error! Try again. ".error, {
                theme: "colored",
            });
        }
    };
    // this will be called when class select dropdown is change and use it to fetch student base on
    // the class id selected.
    // const handleClassChange = (e) => {
    //     var class_data = e.target.value;
    //     setClassId(e.target.value);
    //     // let create the api url here
    //     axios.post(`/api/fetch_all_student_name/`, { id: class_data }).then(res => {
    //         if (res.data.status === 200) {
    //             setAllStudentDetails(res.data.allstudent_list);
    //         }
    //     });

    // };

    // CODE FOR SELECT 2
    const termOptions = [];
    schoolTerm.map((term) => {
        termOptions.push({ value: term.id, label: term.term_name });
    });

    const yearOptions = [];
    schoolYears.map((term) => {
        yearOptions.push({ value: term.id, label: term.academic_name });
    });

    const categoryOptions = [];
    all_category.map((term) => {
        categoryOptions.push({ value: term.id, label: term.sc_name });
    });

    const classOptions = [];
    all_class.map((term) => {
        classOptions.push({ value: term.id, label: term.class_name });
    });

    const subjectOptions = [];
    all_subjects.map((term) => {
        subjectOptions.push({ value: term.id, label: term.subject_name });
    });

    function handleSelect2Input(stateName, selectedItem) {
        setFormData({ ...formData, [stateName]: selectedItem.value });
    }

    // this will be called when class select dropdown is change and use it to fetch student base on
    // the class id selected.
    function handleSelectClassnput(stateName, selectedItem) {
        //alert(selectedItem.value);
        setClassId(selectedItem.value);
        var class_data = selectedItem.value;
        // let create the api url here
        axios.post(`/api/fetch_all_student_name/`, { id: class_data }).then(res => {
            if (res.data.status === 200) {
                setAllStudentDetails(res.data.allstudent_list);
            }
        });
    }


    if (loading) {
        return (
            <div className="card-body">
                <div className="text-center">
                    <div
                        className="spinner-border spinner-border text-info"
                        role="status"
                    ></div>
                </div>
            </div>
        );
    }
    return (
        <>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h4 className="m-0">Single Result Entry {class_id} </h4>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="mr-3">
                                    <Link to="/admin/result">
                                        <button
                                            type="button"
                                            className="btn btn-block btn-info btn-sm" data-tip="View Result" data-place="bottom"
                                        >
                                            View Result
                                        </button>
                                    </Link>{" "}
                                </li>
                                <li className="mr-3">
                                    <Link to="/admin/index">
                                        <button
                                            type="button"
                                            className="btn btn-block btn-dark btn-sm" data-tip="Dashboard" data-place="bottom"
                                        >
                                            <i className="fa fa-home"></i>{" "}
                                        </button>
                                    </Link>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div className="card table-responsive">
                        <div className="card-header">
                            <h3 className="card-title">Single Result Entry! <Link to="#" className="text-danger">Use this module to enter result for selected student</Link></h3>
                        </div>
                        {/* /.card-header */}
                        {isLoading && <div className='overlay text-center'>
                            <div className="spinner-border spinner-border text-info" role="status">
                            </div>
                        </div>}
                        <div className="card-body">
                            <div className="text-center"></div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <Select
                                                name="subject"
                                                options={subjectOptions}
                                                isClearable={true}
                                                isSearchable={true}
                                                isDisabled={false}
                                                isLoading={false}
                                                onChange={(e) => handleSelect2Input("subject", e)}
                                                placeholder="Select Subject"
                                            />
                                            {validationErrors &&
                                                validationErrors[`subject`] ? (
                                                <span className="text-danger">
                                                    {validationErrors[`subject`]}
                                                </span>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <Select
                                                name="term"
                                                options={termOptions}
                                                isClearable={true}
                                                isSearchable={true}
                                                isDisabled={false}
                                                isLoading={false}
                                                onChange={(e) => handleSelect2Input("term", e)}
                                                placeholder="Select Term"
                                            />
                                            {validationErrors &&
                                                validationErrors[`term`] ? (
                                                <span className="text-danger">
                                                    {validationErrors[`term`]}
                                                </span>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <Select
                                                name="year"
                                                options={yearOptions}
                                                isClearable={true}
                                                isSearchable={true}
                                                isDisabled={false}
                                                isLoading={false}
                                                onChange={(e) => handleSelect2Input("year", e)}
                                                placeholder="Select Year"
                                            />
                                            {validationErrors &&
                                                validationErrors[`year`] ? (
                                                <span className="text-danger">
                                                    {validationErrors[`year`]}
                                                </span>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            {/* <select
                                                name="class"
                                                className="form-control"
                                                onChange={(e) => handleClassChange(e)}
                                                required>
                                                <option>Select Class</option>
                                                {all_class.map((item) => {
                                                    return (
                                                        <option key={item.id} value={item.id} >{item.class_name}</option>
                                                    );
                                                })}
                                            </select>
                                            {validationErrors &&
                                                validationErrors[`class`] ? (
                                                <span className="text-danger">
                                                    {validationErrors[`class`]}
                                                </span>
                                            ) : (
                                                ""
                                            )} */}
                                            <Select
                                                name="class"
                                                options={classOptions}
                                                isClearable={true}
                                                isSearchable={true}
                                                isDisabled={false}
                                                isLoading={false}
                                                onChange={(e) => handleSelectClassnput("class", e)}
                                                placeholder="Select Class"
                                            />
                                            {validationErrors &&
                                                validationErrors[`class`] ? (
                                                <span className="text-danger">
                                                    {validationErrors[`class`]}
                                                </span>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <Select
                                                name="school_category"
                                                options={categoryOptions}
                                                isClearable={true}
                                                isSearchable={true}
                                                isDisabled={false}
                                                isLoading={false}
                                                placeholder="Select Category"
                                                onChange={(e) =>
                                                    handleSelect2Input("school_category", e)
                                                }
                                            />
                                            {validationErrors &&
                                                validationErrors[`school_category`] ? (
                                                <span className="text-danger">
                                                    {validationErrors[`school_category`]}
                                                </span>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table
                                id="example1"
                                className="table table-bordered table-striped"
                            >
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>TID</th>
                                        {/* <th>Student Name</th> */}
                                        <th>CA 1</th>
                                        <th>CA 2</th>
                                        <th>Exam </th>
                                        <th>Total</th>
                                        <th>
                                            <span
                                                className="badge bg-primary mr-2"
                                                type="button"
                                                onClick={addRow}
                                            >
                                                <i className="fa fa-plus text-white"></i>
                                            </span>{" "}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, i) => (
                                        <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>
                                                <select
                                                    name="admin_number"
                                                    className="form-control"
                                                    onChange={(e) => handleSelectChange(e, i)}
                                                >
                                                    <option>Select Student</option>
                                                    {all_studentDetails.map((item) => {
                                                        return (
                                                            <option key={item.id} value={item.st_admin_number} >{item.other_name} {item.surname}</option>
                                                        );
                                                    })}
                                                </select>
                                            </td>
                                            {/* <td>
                                                <input
                                                    type="text"
                                                    name="student_name"
                                                    className="form-control"
                                                    placeholder="Student Name"
                                                    onChange={(e) => handleOnChange(e, i)}
                                                />
                                            </td> */}
                                            <td>
                                                <input
                                                    type="text"
                                                    name="ca1_score"
                                                    className="form-control"
                                                    placeholder="CA 1"
                                                    onChange={(e) => handleOnChange(e, i)}
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name="ca2_score"
                                                    className="form-control"
                                                    onChange={(e) => handleOnChange(e, i)}
                                                    placeholder="CA 2"
                                                />
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name="exam_score"
                                                    className="form-control"
                                                    onChange={(e) => handleOnChange(e, i)}
                                                    placeholder="Exam"
                                                />

                                                {validationErrors &&
                                                    validationErrors[`data.${i}.exam_score`] ? (
                                                    <span className="text-danger">
                                                        {validationErrors[`data.${i}.exam_score`][0]}
                                                    </span>
                                                ) : (
                                                    ""
                                                )}
                                            </td>
                                            <td>
                                                <input
                                                    type="text"
                                                    name="total"
                                                    className="form-control"
                                                    onChange={(e) => handleOnChange(e, i)}
                                                    placeholder="total"
                                                    value={row.total}
                                                />
                                            </td>
                                            <td>{
                                                i ? <span className='badge bg-danger mr-2' onClick={(e) => removeRow(e, i)} style={{ cursor: "pointer" }}><i className='fa fa-times text-white'></i></span>
                                                    : null
                                            }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="modal-footer">
                                <button
                                    className="btn btn-success"
                                    disabled={isLoading}
                                    onClick={(e) => onSubmit(e)}
                                >
                                    Proceed
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ReactTooltip />
        </>
    );
}

export default SingleResult;
